export const CheckmarkThinIcon = ({
  width = 24,
  height = 24,
  className,
  title = "Checkmark",
  ...rest
}: IconProps) => {
  return (
    <svg
      data-testid="checkmark-thin-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      {...rest}>
      <title>{title}</title>
      <path
        d="M9 16L13.8696 21L23 11"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      />
    </svg>
  );
};
